// engine
import { ArContainer } from "@aceroll/core";

// game-objects
import { HealthPoint } from './health-point';

export class HealthBar extends ArContainer {
	MAX_HEALTH = 3;

	#healthPoints = [];
	#health = 0;

	constructor() {
		super('health-bar');

		for (let i = 0; i < this.MAX_HEALTH; i++) {
			const hp = new HealthPoint();
			hp.x = i * 200;
			this.addChild(hp);
			this.#healthPoints.push(hp);
		}
	}

	show() {
		const promises = [];

		for (let i = 0; i < this.MAX_HEALTH; i++) {
			const hp = this.#healthPoints[i];
			if (i < this.#health) {
				promises.push(hp.activate());
				continue;
			}
			promises.push(hp.deactivate());
		}

		return Promise.all(promises);
	}

	setHealth(health) {
		this.#health = health;
		return this.show();
	}

	getHealth() {
		return this.#health;
	}

	take(amount = 1) {
		return this.setHealth(Math.max(0, this.#health - amount));
	}

	reset() {
		return this.setHealth(this.MAX_HEALTH);
	}
}
